/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getBooleanDecoder,
  getBooleanEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Hierarchical boundary definition */
export type HierarchicalBoundary = {
  /** Boundary level */
  level: string;
  /** Boundary value */
  value: string;
  /** Include descendants */
  includeDescendants: boolean;
};

export type HierarchicalBoundaryArgs = HierarchicalBoundary;

export function getHierarchicalBoundaryEncoder(): Encoder<HierarchicalBoundaryArgs> {
  return getStructEncoder([
    ["level", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["value", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["includeDescendants", getBooleanEncoder()],
  ]);
}

export function getHierarchicalBoundaryDecoder(): Decoder<HierarchicalBoundary> {
  return getStructDecoder([
    ["level", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["value", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["includeDescendants", getBooleanDecoder()],
  ]);
}

export function getHierarchicalBoundaryCodec(): Codec<
  HierarchicalBoundaryArgs,
  HierarchicalBoundary
> {
  return combineCodec(
    getHierarchicalBoundaryEncoder(),
    getHierarchicalBoundaryDecoder(),
  );
}
